import React from 'react'
// @ts-ignore
import { MediaItem } from '@netbasequid/core'
import { StreamData } from 'types/streamData'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import MediaType from 'enums/MediaType'
import { RichMentionedUrl } from 'schemas/RichMentionedUrlSchema'
import styled from 'styled-components'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'

// In order to be compatible with lightbox's interface
type VideoOrImageRichMentionedUrl =
  | (Omit<RichMentionedUrl, 'mediaType'> & { mediaType: 'Video' })
  | (Omit<RichMentionedUrl, 'mediaType'> & { mediaType: 'Image' })
  | (Omit<RichMentionedUrl, 'mediaType'> & { mediaType: 'Audio' })

export type MediaClickHandler = (mediaUrls: VideoOrImageRichMentionedUrl[], index: number) => void

const filterVideoOrImageMedia = (mediaUrls: RichMentionedUrl[]) =>
  mediaUrls.filter(
    (mediaUrl) =>
      mediaUrl.mediaType === MediaType.IMAGE ||
      mediaUrl.mediaType === MediaType.VIDEO ||
      mediaUrl.mediaType === MediaType.AUDIO
  ) as VideoOrImageRichMentionedUrl[]

const MediaContainer = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.mediaGrid
})<{ isDisplay: boolean }>`
  display: ${({ isDisplay }) => (isDisplay ? 'flex' : 'none')};
  gap: 8px;
  flex-wrap: wrap;
`

export interface MediaGridProps {
  streamData: StreamData
  display: boolean
  onMediaClick?: MediaClickHandler
}
const MediaGrid = ({ streamData, display, onMediaClick }: MediaGridProps): React.ReactElement => {
  const theme = useDisplayTheme() as Theme

  const { mediaUrls } = streamData

  if (!mediaUrls) {
    return <></>
  }

  const videoOrImageMediaUrls = filterVideoOrImageMedia(mediaUrls)

  return (
    <>
      <MediaContainer isDisplay={display}>
        {videoOrImageMediaUrls.map((mediaUrl, index) => (
          <MediaItem
            mode={theme}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            data={mediaUrl}
            width="200px"
            height="200px"
            previewNaUrl="https://help.quid.com/articles/8240236#h_24b221c46b"
            previewNaUrlWording="More..."
            previewNaWording="Preview not available."
            onClick={() => onMediaClick && onMediaClick(videoOrImageMediaUrls, index)}
          />
        ))}
      </MediaContainer>
    </>
  )
}

export default MediaGrid
